<template>
	<section id="footer">© {{ year }} {{ $t('layout.mcdonalds') }} <a :href="template_url" target="_blank">{{ $t('layout.privacy_policy') }}</a></section>
</template>

<script>

export default {
  data () {
    return {
     year: moment().format('YYYY'),
     template_url : process.env.VUE_APP_API_URL + "/static/pdf/politicascondiciones.pdf",
    }
  },
  computed: {
   
  },
  methods: {
  	
  }
}
</script>

<style lang="scss" scoped>

	#footer {
		width: 100%;
		height: 20px;
    margin-top: 30px;
    margin-bottom: 20px;
    bottom: 20px;
    z-index: -1;
    text-align: right;
    padding-right: 50px;
    color: #999;
  }
    #footer a {
        text-decoration: none;
        color: #666;
        margin-right: 15px;

        &:hover {
          text-decoration: underline;
        }
    }

</style>
